var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotiselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-48 -201.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notification-status",
    transform: "translate(48 201.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M19,8a3,3,0,1,1,3-3A3,3,0,0,1,19,8Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M19.74,9.43c-.1.02-.2.03-.31.05a4.65,4.65,0,0,1-1.33-.07,3.178,3.178,0,0,1-.33-.09,3.436,3.436,0,0,1-.93-.38,4.05,4.05,0,0,1-.35-.21,4.717,4.717,0,0,1-1.22-1.22,4.05,4.05,0,0,1-.21-.35,3.436,3.436,0,0,1-.38-.93,3.178,3.178,0,0,1-.09-.33,4.65,4.65,0,0,1-.07-1.33c.02-.11.03-.21.05-.31,0-.02.01-.04.01-.06A1,1,0,0,0,13.6,3H7.52c-.14,0-.28.01-.41.02s-.23.02-.35.04-.24.03-.35.05a4.769,4.769,0,0,0-4.3,4.3c-.02.11-.04.23-.05.35s-.03.23-.04.35S2,8.38,2,8.52v7.96c0,.14.01.28.02.41s.02.23.04.35.03.24.05.35a4.769,4.769,0,0,0,4.3,4.3c.11.02.23.04.35.05s.23.03.35.04.27.02.41.02h7.96c.14,0,.28-.01.41-.02s.23-.02.35-.04.24-.03.35-.05a4.769,4.769,0,0,0,4.3-4.3c.02-.11.04-.23.05-.35s.03-.23.04-.35.02-.27.02-.41V10.4a1,1,0,0,0-1.2-.98C19.78,9.42,19.76,9.43,19.74,9.43ZM11.75,12.5a.75.75,0,0,1,0,1.5h-5a.75.75,0,0,1,0-1.5Zm-5,5.5a.75.75,0,0,1,0-1.5h9a.75.75,0,0,1,0,1.5Z",
    fill: "#15345a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiselected);
export default __webpack_public_path__ + "static/media/notiselected.0dbbe8b5518d39ef61a99b46ff95faa0.svg";
export { ForwardRef as ReactComponent };